var map = {
	"./game/background/calm1.png": 701,
	"./game/background/calm2.png": 870,
	"./game/background/calm3.png": 367,
	"./game/background/calm4.png": 224,
	"./game/background/cloud1.png": 215,
	"./game/background/cloud2.png": 804,
	"./game/background/cloud3.png": 253,
	"./game/background/cloud4.png": 746,
	"./game/background/night1.png": 568,
	"./game/background/night2.png": 427,
	"./game/background/night3.png": 322,
	"./game/background/night4.png": 445,
	"./game/background/phone.png": 115,
	"./game/background/storm1.png": 775,
	"./game/background/sunset1.png": 936,
	"./game/background/sunset2.png": 795,
	"./game/background/sunset3.png": 570,
	"./game/background/sunset4.png": 517,
	"./website/header/header_email.png": 973,
	"./website/header/header_menu.png": 240,
	"./website/header/header_pfp.png": 79,
	"./website/header/header_setting.png": 357,
	"./website/homePage/homepage_background.jpg": 255,
	"./website/loginPage/loginPage_background.jpg": 941,
	"./website/placeholder/empty_pfp.jpg": 807,
	"./website/startPage/h.jpg": 21,
	"./website/startPage/startPage_background.jpg": 121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;